import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { GrNext } from "react-icons/gr";

const Container = styled.div`
  width: 100%;
  max-width: 720px;
  height: 600px;
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 35px auto 0 auto;
`;

const VideoPlaceholder = styled.div`
  width: 100%;
  height: 500px;
  background-color: #e9ecef;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6c757d;
  font-size: 18px;
  margin-bottom: 20px;
  padding: 20px;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const Button = styled.button`
  background-color: #6ab292;
  color: white;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  padding: 8px 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #5a9e82;
  }

  .material-symbols-outlined {
    font-size: 24px;  /* Tamanho do ícone */
    font-variation-settings: 
    'wght' 200;     /* Define a espessura mais fina */
  }
`;

const VideoComponent = () => {
  const navigate = useNavigate();

  const handlePrefiroLer = () => {
    navigate('/TextIntro');
  };

  const handleNext = () => {
    navigate('/TermoCooperacao');
  };

  return (
    <Container>
      <VideoPlaceholder>
        Vídeo com avatar (explicativo)
      </VideoPlaceholder>
      
      <ButtonContainer>
        <Button onClick={handlePrefiroLer}>
          <span className="material-symbols-outlined">description</span> Prefiro ler
        </Button>
        <Button onClick={handleNext}>
          Próximo <span class="material-symbols-outlined" style={{ fontSize: '20px' }}>arrow_forward_ios</span>
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default VideoComponent;
